
import { OrganisationDto } from "@aoe/client";
import { createReducer, on } from "@ngrx/store";
import { organisationActions } from "./organisation.actions";

export interface OrganisationState {
    organisations: OrganisationDto[];
    loading: boolean;
    error?: any,
    warning?: any;
    info?: any;
}

export const initialeState: OrganisationState = {
    organisations: [],
    loading: true
}

export const organisationReducer = createReducer(
    initialeState,
    on(
        organisationActions["[Organisation-API]LoadOrganisation"], state => ({
            ...state,
            loading: true
        })
    ),
    on(
        organisationActions["[Organisation-API]LoadSuccess"], (state, res) => ({
            ...state,
            loading: false,
            organisations: res.data?.organisations ?? [],
            nb: res.data?.nb ?? 0,
            info: res.info,
            warning: res.warning,
        })
    ),
    on(
        organisationActions["[Organisation-API]LoadFailed"], (state, res) => ({
            ...state,
            loading: false,
            error: res.error
        })),
    on(
        organisationActions["created"], (state, res) => ({
            ...state,
            loading: false,
            organisations: res.data ? [...state.organisations, res.data] : state.organisations,
            nb: res.data ? state.organisations.length + 1 : state.organisations.length ?? 0,
            info: res.info,
            warning: res.warning,
        })),
    on(organisationActions["createFailed"], (state, res) => ({
        ...state,
        loading: false,
        error: res.error
    }))
)